import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
    { to: "/zakat", label: "حاسبة الزكاة" },
    { to: "https://wa.me/message/PBZXECOCDIFXK1", label: "تواصل معنا", external: true },
];

export default function Header() {
    const [open, setOpen] = useState(false);

    return (
        <header
            className="sticky top-0 z-50 backdrop-blur-xl bg-[#F5FBFA]/90 border-b border-[#4FB8B0]/20"
            data-testid="site-header"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="h-16 md:h-20 flex items-center justify-between flex-row-reverse">
                    <Link
                        to="/"
                        data-testid="logo-link"
                        className="flex items-center gap-3"
                    >
                        <img
                            src="/logo.png"
                            alt="أسعار الذهب اليوم"
                            className="w-10 h-10 md:w-12 md:h-12 rounded-lg object-cover shadow-md"
                        />
                        <span className="font-heading text-lg md:text-2xl font-bold text-[#0F2A28] leading-none">
                            أسعار الذهب{" "}
                            <span className="brand-shimmer">اليوم</span>
                        </span>
                    </Link>

                    <nav className="hidden lg:flex items-center gap-1">
                        {links.map((l) =>
                            l.external ? (
                                <a
                                    key={l.to}
                                    href={l.to}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="nav-contact"
                                    className="px-3 py-2 text-sm font-medium text-[#1E5E5A]/70 hover:text-[#0F2A28] transition-colors"
                                >
                                    {l.label}
                                </a>
                            ) : (
                                <NavLink
                                    key={l.to}
                                    to={l.to}
                                    data-testid={`nav-${l.to.replace("/", "") || "home"}`}
                                    className={({ isActive }) =>
                                        `px-3 py-2 text-sm font-medium transition-colors ${
                                            isActive
                                                ? "text-[#0F2A28] border-b-2 border-[#4FB8B0]"
                                                : "text-[#1E5E5A]/70 hover:text-[#0F2A28]"
                                        }`
                                    }
                                    end={l.to === "/"}
                                >
                                    {l.label}
                                </NavLink>
                            )
                        )}
                    </nav>

                    <button
                        data-testid="mobile-menu-toggle"
                        onClick={() => setOpen(!open)}
                        className="lg:hidden p-2 -me-2 text-[#0F2A28]"
                        aria-label="menu"
                    >
                        {open ? <X size={22} /> : <Menu size={22} />}
                    </button>
                </div>

                {open && (
                    <nav
                        data-testid="mobile-nav"
                        className="lg:hidden pb-4 grid grid-cols-2 gap-1 border-t border-[#4FB8B0]/20 pt-3"
                    >
                        {links.map((l) =>
                            l.external ? (
                                <a
                                    key={l.to}
                                    href={l.to}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => setOpen(false)}
                                    data-testid="mobile-nav-contact"
                                    className="px-3 py-2 text-sm rounded text-[#1E5E5A] hover:bg-[#4FB8B0]/10"
                                >
                                    {l.label}
                                </a>
                            ) : (
                                <NavLink
                                    key={l.to}
                                    to={l.to}
                                    onClick={() => setOpen(false)}
                                    data-testid="mobile-nav-zakat"
                                    className={({ isActive }) =>
                                        `px-3 py-2 text-sm rounded ${
                                            isActive
                                                ? "bg-[#1E5E5A] text-white"
                                                : "text-[#1E5E5A] hover:bg-[#4FB8B0]/10"
                                        }`
                                    }
                                    end={l.to === "/"}
                                >
                                    {l.label}
                                </NavLink>
                            )
                        )}
                    </nav>
                )}
            </div>
        </header>
    );
}
